import React, { Fragment, useEffect } from 'react';
import { Row, Col, Space } from 'antd';
import { SearchOutlined, ReloadOutlined, PlusOutlined } from '@ant-design/icons';
import {
  CustomButton,
  CustomModal,
  FormDatePicker,
  FormInput,
  FormSelect,
} from '../../../../components';
import { ShareResponse } from '../../../../share';
import AdvancedFilters from './AdvancedFilters';

interface SearchRowProps {
  formik: any;
  states?: ShareResponse[];
  onCancel: () => void;
  isLoading?: boolean;
}

const SearchRow: React.FC<SearchRowProps> = ({
  formik,
  states,
  onCancel,
  isLoading,
}) => {
  const [modalAdvancedFilters, setModalAdvancedFilters] =
    React.useState<boolean>(false);
  const [advancedFilters, setAdvancedFilters] = React.useState<any>({});
  const [filterState, setFilterState] = React.useState<any>({});

  const onAdvancedFilters = () => {
    let params = {
      ticket: formik.values.ticket,
      status_id: formik.values.status_id,
      created_at: formik.values.created_at,
    };
    Object.keys(advancedFilters).forEach((filterId) => {
      params = { ...params, [filterId]: advancedFilters[filterId]?.value };
    });
    formik.setValues(params);
    formik.handleSubmit();
    setModalAdvancedFilters(false);
  };

  useEffect(() => {
    const excludedIds = [3, 9, 10, 14, 16, 28, 72];
    if (!states) {
      setFilterState([]);
      return;
    }
    setFilterState(states.filter(state => !excludedIds.includes(Number(state.id))));
  }, [states]);

  return (
    <Fragment>
      <Row gutter={[16, 16]} className="container-filters">
        <Col xs={24} sm={12} md={8}>
          <FormInput
            label="Número de ticket"
            name="ticket"
            placeholder="Ingrese número de ticket"
            value={formik.values.ticket}
            error={formik.errors.ticket}
            touched={formik.touched.ticket}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Col>
        <Col xs={24} sm={12} md={8}>
          <FormSelect
            label="Estado de la solicitud"
            name="status_id"
            placeholder="Seleccione estado"
            value={formik.values.status_id}
            options={filterState}
            error={formik.errors.status_id}
            touched={formik.touched.status_id}
            onChange={(value) => formik.setFieldValue('status_id', value)}
            onBlur={formik.handleBlur}
          />
        </Col>

        <Col xs={24} sm={12} md={8}>
          <FormDatePicker
            label="Fecha solicitud"
            name="created_at"
            value={formik.values.created_at}
            error={formik.errors.created_at}
            touched={formik.touched.created_at}
            onChange={(value) => formik.setFieldValue('created_at', value)}
            onBlur={formik.handleBlur}
          />
        </Col>
      </Row>

      <Row className="filters-buttons">
        <Col xs={24} sm={12} md={6}>
          <Space>
            <CustomButton
              buttonType="secondary"
              label="Limpiar"
              onClick={() => onCancel()}
              icon={<ReloadOutlined />}
              size="middle"
              disabled={isLoading}
              customClass={isLoading ? 'BtnClear_Desactived' : 'BtnClear'}
            />
            <CustomButton
              label="Buscar"
              onClick={formik.handleSubmit}
              icon={<SearchOutlined />}
              size="middle"
              disabled={isLoading}
              customClass={isLoading ? 'BtnSearch_Desactived' : 'BtnSearch'}
            />
            <CustomButton
              label="Filtros avanzados"
              onClick={() => setModalAdvancedFilters(true)}
              icon={<PlusOutlined />}
              size="middle"
              disabled={isLoading}
              customClass={isLoading ? 'BtnSearchAdvanced_Desactived' : 'BtnSearchAdvanced'}

            />
          </Space>
        </Col>
      </Row>
      <CustomModal
        title="Filtros avanzados"
        labelSubmit="Aceptar"
        open={modalAdvancedFilters}
        width={1500}
        onCancel={() => setModalAdvancedFilters(false)}
        onSave={onAdvancedFilters}
        disabledBtn={!Object.keys(advancedFilters).length}
      >
        <AdvancedFilters
          formik={formik}
          onCancel={() => setModalAdvancedFilters(false)}
          filters={advancedFilters}
          setFilters={setAdvancedFilters}
        />
      </CustomModal>
    </Fragment>
  );
};

export default SearchRow;
